import React, { useEffect } from 'react';

import ErrorIcon from '@/assets/img/error.svg?react';
import Heading from '@/components/common/Heading/Heading';
import SectionCard from '@/components/common/SectionCard/SectionCard';
import Spinner from '@/components/common/Spinner/Spinner';

import BillingAndRenewalsForm from './components/BillingAndRenewalsForm';
import useGetRenewalSettings from './hooks/useGetRenewalSettings';
import useUpdateRenewalSettings from './hooks/useUpdateRenewalSettings';

export default function BillingAndRenewalsContainer() {
  const { getRenewalSettings, isLoadingGetRenewalSettings, renewalSettings } = useGetRenewalSettings();
  const { updateRenewalSettings } = useUpdateRenewalSettings();

  useEffect(() => {
    getRenewalSettings();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  return (
    <div className="row">
      <div className="col-6">
        <SectionCard
          padding={true}
          title={{ titleText: 'Renewal Global Settings' }}
        >
          {isLoadingGetRenewalSettings && (
            <div className="mt-40 mb-40 d-flex justify-content-center">
              <Spinner />
            </div>
          )}

          {renewalSettings.length > 0 && !isLoadingGetRenewalSettings && (
            <>
              <div className="mb-20">
                <Heading level={3}><b>Billing Interval</b></Heading>
              </div>

              <BillingAndRenewalsForm
                renewalSettings={renewalSettings}
                onSubmit={updateRenewalSettings}
              />
            </>
          )}
        </SectionCard>
      </div>

      <div className="col-6">
        <SectionCard
          padding={true}
          title={{ titleText: 'Billing Global Settings' }}
        >
          <div className="d-flex flex-column align-items-center mt-50">
            <ErrorIcon />
            <p>The section is under development</p>
          </div>
        </SectionCard>
      </div>
    </div>
  );
}
